import { StoryLevelData } from "@/app/lib/levels/story-level-data-types";
import { parseBuilderText } from "@/app/builder/build-parser";

const builderText =
`"mirror mirror"
SEEs
pOOp
nOOn
kOOk
kaYak
#pkasn

mAdAm
rAdAr
rEfEr
roTATor
dEIfIEd
#dfrmo
`

const id = 'palindromes-0.11'

const parsed = parseBuilderText(builderText, id);

if (parsed.levelData === null) {
    throw new Error(`Invalid builder text for ${id}, with errors:`);
}

export const palindromes: StoryLevelData = parsed.levelData;